module.exports = __webpack_public_path__ + "img/socicon.a35b657.svg";